import type React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import type {
  IStreamDetails,
  IThemeConfig,
} from "../components/types/memorial-types";
import sunsetbackground from "../../../../../assets/sunset-background.png";

interface ThemedHeaderProps {
  stream: IStreamDetails;
  theme: IThemeConfig;
}

const ThemedHeader: React.FC<ThemedHeaderProps> = ({ stream, theme }) => {
  const deceased = stream.booking.deceased[0];
  const fullName = `${deceased?.first_name || ""} ${
    deceased?.second_name || ""
  } ${deceased?.surname || ""}`.trim();

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      {/* Background Image */}
      <Box
        sx={{
          height: { xs: "80px", md: "100px" },
          backgroundImage: `url(${sunsetbackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* Content */}
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "center", md: "center" },
          justifyContent: { xs: "center", md: "flex-start" },
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 1.5, md: 3 },
          px: { xs: 2, md: 25 },
          py: 2,
          textAlign: { xs: "center", md: "left" },
        }}
      >
        {/* Avatar */}
        <Avatar
          src={deceased?.person_image}
          sx={{
            width: { xs: 80, md: 120 },
            height: { xs: 80, md: 120 },
            borderRadius: "12px",
            border: `3px solid ${theme.background} `,
            mt: { xs: -6, md: -8 },
          }}
        />

        {/* Text Content */}
        <Box>
          <Typography
            variant="body1"
            sx={{
              fontStyle: "italic",
              fontFamily: '"Freehand", cursive',
              fontSize: { xs: "1rem", md: "1.2rem" },
              color: "text.secondary",
              mb: 1,
            }}
          >
            In Loving Memory Of
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              color: "black",
              fontSize: { xs: "1.5rem", md: "2rem" },
            }}
          >
            {fullName}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ThemedHeader;
